/* Promocion viva. 16-oct-2026.
 * Lee window.anPromo (metacampo de la tienda custom.promo_escalera) y responde si
 * la fecha actual esta dentro de la ventana. Sin dato o fuera de fechas: null.
 */
window.anPromoViva = function () {
  var p = window.anPromo;
  if (!p || !p.inicio || !p.fin) { return null; }
  var ahora = Date.now();
  if (ahora < Date.parse(p.inicio) || ahora > Date.parse(p.fin)) { return null; }
  return p;
};

/* Hace funcionar el boton "Agregar" de las sugerencias del carrito.
 *
 * Por que existe este archivo. La logica vivia en un <script> dentro de
 * `snippets/cart-line-items.liquid`, y nunca se ejecutaba: el cajon del
 * carrito se clona desde un <template>, y el contenido de un template es
 * inerte, asi que sus <script> no corren. Resultado medido el 10-oct-2026 en
 * el tema vivo: `window.anVaBienCon` estaba undefined y el boton no agregaba
 * nada. Las tarjetas se veian bien y no hacian nada.
 *
 * Desde un asset del tema el oyente se registra una sola vez en el documento
 * y sobrevive a que el cajon se vuelva a pintar.
 */
(function () {
  'use strict';
  if (window.anVaBienCon) { return; }
  window.anVaBienCon = 1;

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-an-va-add]');
    if (!b || b.getAttribute('data-hecho') || b.getAttribute('data-enviando')) { return; }
    e.preventDefault();
    // el seguro se pone YA, no cuando responda el servidor: tres toques
    // seguidos en un movil metian tres unidades (probado el 10-oct-2026)
    b.setAttribute('data-enviando', '1');
    b.setAttribute('aria-disabled', 'true');

    // con selector de tamano manda la variante elegida, no la del atributo
    var sel = b.hasAttribute('data-an-va-sel')
      ? (b.closest('.an-va__it') || b.parentNode).querySelector('.an-va__sel')
      : null;
    var id = Number(sel ? sel.value : b.getAttribute('data-an-va-add'));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('no se pudo agregar'); }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      b.textContent = 'En tu carrito';
      b.setAttribute('data-hecho', '1');
      b.removeAttribute('data-enviando');
      b.classList.add('an-va__btn--hecho');
      b.removeAttribute('aria-disabled');
    }).catch(function () {
      b.removeAttribute('data-enviando');
      // si falla, se lleva a la ficha en vez de dejarla sin respuesta
      var a = (b.closest('.an-va__it') || {}).querySelector
        ? b.closest('.an-va__it').querySelector('.an-va__nom') : null;
      if (a && a.href) { window.location = a.href; }
      else { b.removeAttribute('aria-disabled'); }
    });
  });
})();


/* La linea del regalo del carrito.
 *
 * Las fechas y el umbral del regalo no se escriben en el tema: se leen en vivo
 * de BOGOS (window.fgData.offers), que es la unica fuente que sabe cuando
 * empieza y cuando termina una campana. El 9-oct-2026 la pagina siguio
 * ofreciendo un suero de regalo doce horas despues de que la campana cerrara,
 * una clienta pregunto, se le confirmo, y no llego nada. Fuera de las fechas
 * esta linea simplemente no existe.
 *
 * El total del carrito lo pone Liquid en data-an-total. El cajon se vuelve a
 * pintar en el servidor con cada cambio, asi que no hace falta pedir /cart.js.
 */
(function () {
  'use strict';
  if (window.anRegaloCarrito) { return; }
  window.anRegaloCarrito = 1;

  function pesos(centavos) {
    return '$' + Math.round(centavos / 100).toLocaleString('es-CO').replace(/,/g, '.');
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // BOGOS manda las fechas con microsegundos (2026-10-13T05:00:00.000000Z) y
  // no todos los navegadores las parsean: se recortan a milisegundos.
  function cuando(t) {
    return Date.parse(String(t || '').replace(/(\.\d{3})\d+/, '$1'));
  }

  // Fotos reales de los frascos de 10 ml (14-oct-2026). BOGOS guarda la del
  // frasco de 30 ml y no la relee; aqui se cambia por la del regalo de verdad.
  var FOTO_10ML = {
    'suero-hidratante-acido-hialuronico-1-5': 'https://cdn.shopify.com/s/files/1/0674/6531/4584/files/10ml_Suero_hidratante_ah__ANIMUS_LAB.jpg?v=1791999460',
    'suero-de-niacinamida': 'https://cdn.shopify.com/s/files/1/0674/6531/4584/files/10ml_Suero_de_niacinamida__ANIMUS_LAB.jpg?v=1791999469',
    'suero-iluminador-trx': 'https://cdn.shopify.com/s/files/1/0674/6531/4584/files/10ml_Suero_iluminador_trx__ANIMUS_LAB.jpg?v=1791999477'
  };
  var FOTO_10ML_TEXTO = [
    [/hialur/i, 'suero-hidratante-acido-hialuronico-1-5'],
    [/niacinamida/i, 'suero-de-niacinamida'],
    [/trx/i, 'suero-iluminador-trx']
  ];

  // en la ventana de BOGOS cada suero trae la foto de 30 ml: se cambia por la
  // de 10 ml segun el nombre de la tarjeta
  function fotosVentana() {
    var botones = document.querySelectorAll('.bogos-gift-slider-modal .bogos-gift-item-add-btn');
    for (var i = 0; i < botones.length; i++) {
      var t = botones[i].parentElement;
      while (t && !t.querySelector('img') && !t.classList.contains('bogos-gift-slider-modal')) { t = t.parentElement; }
      if (!t || t.classList.contains('bogos-gift-slider-modal')) { continue; }
      var texto = (botones[i].getAttribute('aria-label') || '') + ' ' + t.textContent;
      for (var k = 0; k < FOTO_10ML_TEXTO.length; k++) {
        if (!FOTO_10ML_TEXTO[k][0].test(texto)) { continue; }
        var url = FOTO_10ML[FOTO_10ML_TEXTO[k][1]] + '&width=400';
        var im = t.querySelector('img');
        if (im && im.getAttribute('src') !== url) {
          im.removeAttribute('srcset');
          im.setAttribute('src', url);
        }
        break;
      }
    }
  }
  new MutationObserver(function () { fotosVentana(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  // 20-oct-2026: BOGOS puede tener varias ofertas vivas a la vez, una por
  // escalon de monto (min y max). Cada una se lee igual y despues se escoge la
  // que corresponde al total del carrito.
  function limpia(s) {
    return String(s || '').replace(/\s*\(\s*100\s*%\s*off\s*\)\s*/i, '')
      .replace(/[​-‍﻿]/g, '').trim();
  }

  // 20-oct-2026: BOGOS guarda una sola foto para todos los tonos del Lip
  // Serum. La de cada tono se lee una vez de la ficha original.
  var FOTOS_TONO = {}, PIDIENDO = {};
  // 31-oct-2026: un tono agotado no se ofrece (se lee available de la ficha)
  var DISP_TONO = {};
  function fotoTono(h, idv) {
    if (!h) { return ''; }
    if (FOTOS_TONO[h]) { return FOTOS_TONO[h][String(idv)] || ''; }
    if (!PIDIENDO[h]) {
      PIDIENDO[h] = 1;
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var m = {}, d = {};
        (p.variants || []).forEach(function (x) {
          if (x.featured_image && x.featured_image.src) { m[String(x.id)] = x.featured_image.src; }
          d[String(x.id)] = !!x.available;
        });
        FOTOS_TONO[h] = m;
        DISP_TONO[h] = d;
        window.anFotosVer = (window.anFotosVer || 0) + 1;
        agenda();
      }).catch(function () {});
    }
    return '';
  }

  function leeOferta(o, ahora) {
    var ini = cuando(o.start_time);
    var fin = cuando(o.end_time);
    if (!ini || !fin || ahora < ini || ahora > fin) { return null; }
    var cond = (o.offer_conditions || [])[0] || {};
    var min = parseFloat(cond.min_amount);
    if (!min) { return null; }
    var max = parseFloat(cond.max_amount);
    var gp = o.gift_products || [];
    var nombre = limpia((gp[0] || {}).title || (gp[0] || {}).name);
    // 31-oct-2026: BOGOS puede guardar «Vela - Diseño sorpresa» o «(regalo)»
    nombre = nombre.replace(/\s+-\s+.*$/, '').replace(/\s*\(\s*regalo\s*\)\s*$/i, '').trim();
    if (!nombre) { return null; }
    // 12-oct-2026: si todos los regalos son sueros se dice «suero»
    var todosSuero = gp.length > 1 && gp.every(function (g) {
      return /suero/i.test(String(g.title || g.name || ''));
    });
    // un solo producto con varios tonos (Lip Serum): se elige el tono
    var tonos = gp.length === 1 && ((gp[0] || {}).variants || []).length > 1;
    var handles = gp.map(function (g) {
      return String(g.original_product_handle || '');
    }).filter(Boolean);
    var regalos = [];
    gp.forEach(function (g) {
      var h = String(g.original_product_handle || '');
      var vs = g.variants || [];
      (tonos ? vs : [vs[0] || {}]).forEach(function (v) {
        if (tonos && DISP_TONO[h] && DISP_TONO[h][String(v.original_variant_shopify_id)] === false) { return; }
        var corto = tonos ? String(v.variant_title || v.title || '').trim()
          : /niacinamida/i.test(h) ? 'Niacinamida'
          : /hialuron/i.test(h) ? 'Hialurónico'
          : /trx/i.test(h) ? 'TRX'
          : limpia(g.title).split('|')[0].replace(/^suero\s+(de\s+)?/i, '').trim();
        var ml = String(v.variant_title || v.title || '').replace(/^\s*(\d+)\s*ml\s*$/i, '$1 ml');
        var img = FOTO_10ML[h] || (tonos && fotoTono(h, v.original_variant_shopify_id)) ||
          String(v.thumbnail || v.image || g.thumbnail || '');
        if (img && img.indexOf('cdn.shopify.com') > -1) {
          img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        }
        regalos.push({ corto: corto, ml: !tonos && /ml$/.test(ml) ? ml : '', img: img,
                       variante: String(v.variant_shopify_id || '') });
      });
    });
    // 31-oct-2026: si todos los tonos se agotaron, la oferta no se anuncia
    if (!regalos.length) { return null; }
    // como se nombra el regalo en las frases: «suero», «Lip Sérum», «regalo»
    var palabra = todosSuero ? 'suero'
      : gp.length === 1 ? nombre.split(/\s+/).slice(0, 2).join(' ')
      : 'regalo';
    var cuales = gp.length === 1 ? 'un ' + palabra
      : gp.map(function (g) { return limpia(g.title).split('|')[0].trim(); }).join(' o ');
    // 31-oct-2026: la vela y el Charm se nombran como los dice la marca
    var un = 'un ' + palabra;
    if (/vela/i.test(nombre)) { palabra = 'vela'; nombre = 'vela de cera de abeja'; un = 'una vela de cera de abeja'; }
    else if (/charm/i.test(nombre)) { palabra = 'Charm'; un = 'un Charm'; }
    if (gp.length === 1) { cuales = un; }
    return { id: String(o.id || ''), min: Math.round(min * 100),
             max: max ? Math.round(max * 100) : 0, nombre: nombre,
             varios: regalos.length > 1, palabra: palabra, cuales: cuales, un: un,
             handles: handles, regalos: regalos, fin: fin };
  }

  function ofertasVivas() {
    var lista = (window.fgData && window.fgData.offers) || [];
    var ahora = Date.now();
    var out = [];
    for (var i = 0; i < lista.length; i++) {
      var x = leeOferta(lista[i] || {}, ahora);
      if (x) { out.push(x); }
    }
    return out.sort(function (a, b) { return a.min - b.min; });
  }

  // el escalon mas bajo: es el que anuncia la barra
  function ofertaViva() {
    return ofertasVivas()[0] || null;
  }

  // la oferta que toca con este total y la del escalon siguiente
  function ofertaPara(total) {
    var l = ofertasVivas();
    var toca = null;
    for (var i = 0; i < l.length; i++) {
      if (total >= l[i].min && (!l[i].max || total <= l[i].max)) { toca = l[i]; }
    }
    var arriba = null;
    for (var j = 0; j < l.length; j++) {
      if (l[j].min > total) { arriba = l[j]; break; }
    }
    return toca ? { oferta: toca, siguiente: arriba } : { oferta: arriba, siguiente: null };
  }

  // la barra de anuncios usa la misma regla, para que no haya dos versiones
  window.anOfertaViva = ofertaViva;
  window.anOfertaPara = ofertaPara;
  window.anOfertasVivas = ofertasVivas;

  // Barra de metas del carrito, 13-oct-2026: una sola barra con el regalo de
  // la semana y el envio gratis, el mismo dibujo que la rutina de la ficha
  // (regla 49). Va en spans porque vive dentro de un <p>.
  function barraMetas(ya, regalo, tope) {
    var f = function (x) { return Math.max(0, Math.min(1, x / tope)); };
    var hitos = '';
    if (regalo && regalo < tope) {
      hitos += '<span class="an-ru__hito' + (ya >= regalo ? ' an-ru__hito--listo' : '') +
        '" style="left:' + (f(regalo) * 100).toFixed(1) + '%">Regalo</span>';
    }
    hitos += '<span class="an-ru__hito an-ru__hito--fin' + (ya >= tope ? ' an-ru__hito--listo' : '') +
      '">Envío<span class="an-ru__hito-mas"> gratis</span></span>';
    return '<span class="an-ru__meta an-metas__meta" data-an-ya="' + f(ya) + '" style="--an-ru-ya:0;--an-ru-suma:0;--an-ru-hito:' +
      (regalo && regalo < tope ? (f(regalo) * 100).toFixed(1) + '%' : '-10px') + '">' +
      '<span class="an-ru__barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      Math.round(f(ya) * 100) + '" aria-label="Avance hacia el envío gratis"><span class="an-ru__ya"></span></span>' +
      '<span class="an-ru__hitos" aria-hidden="true">' + hitos + '</span></span>';
  }

  // la barra arranca en cero y se llena: se nota que avanzo
  // 20-oct-2026: barra con toda la escalera (regalos de BOGOS y envio gratis)
  function corto(t) {
    return t.palabra === 'suero' ? 'Suero'
      : t.palabra === 'regalo' ? String(t.cuales).split(' o ')[0].split(' ')[0]
      : t.palabra;
  }
  function metasEscalera(total, envio) {
    var todas = window.anOfertasVivas ? window.anOfertasVivas() : [];
    // 28-oct-2026: un regalo de cualquier compra (minimo $1) no es una meta: ya esta ganado
    var hitos = todas.filter(function (t) { return t.min > 100; })
      .map(function (t) { return { v: t.min, l: corto(t) }; });
    hitos.push({ v: envio, l: 'Envío gratis', envio: true });
    hitos.sort(function (a, b) { return a.v - b.v; });
    var tope = hitos[hitos.length - 1].v;
    var f = function (x) { return Math.max(0, Math.min(1, x / tope)); };
    var marcas = hitos.map(function (h, i) {
      var p = (f(h.v) * 100).toFixed(1);
      var on = total >= h.v ? ' is-on' : '';
      var pos = i === hitos.length - 1 ? ' an-mt__l--fin' : '';
      return '<span class="an-mt__m' + on + (h.envio ? ' an-mt__m--envio' : '') + '" style="left:' + p + '%"></span>' +
        '<span class="an-mt__l' + on + (h.envio ? ' an-mt__l--envio' : '') + pos + '" style="left:' + p + '%">' + esc(h.l) + '</span>';
    }).join('');
    return '<span class="an-mt" data-an-ya="' + f(total).toFixed(3) + '" style="--ya:0">' +
      '<span class="an-mt__barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      Math.round(f(total) * 100) + '" aria-label="Avance hacia tus regalos y el envío gratis">' +
      '<span class="an-mt__ya"></span>' + marcas + '</span></span>';
  }
  // 28-oct-2026: cuando ya no falta nada, una barra llena no dice nada; se dice lo que gano
  function logros(oferta, total, envio) {
    var l = [];
    if (oferta && total >= oferta.min) {
      l.push(oferta.palabra === 'regalo' ? 'Regalo' : (oferta.palabra.charAt(0).toUpperCase() +
        oferta.palabra.slice(1) + ' de regalo'));
    }
    if (total >= envio) { l.push('Envío gratis'); }
    if (!l.length) { return ''; }
    return '<span class="an-logros"><span class="an-logros__t">Desbloqueaste</span>' +
      l.map(function (x, i) {
        return '<span class="an-logro" style="--i:' + i + '"><span class="an-logro__p" aria-hidden="true"></span>' +
          esc(x) + '</span>';
      }).join('') + '</span>';
  }
  function lineaFaltan(total, envio, sig, ganado) {
    var p = [];
    if (total < envio) { p.push('<strong>' + pesos(envio - total) + '</strong> para el envío gratis'); }
    if (ganado && sig) {
      p.push('<strong>' + pesos(sig.min - total) + '</strong> para desbloquear ' + esc(sig.un || sig.cuales));
    }
    var gratis = total >= envio ? 'Tu <strong>envío es gratis</strong>. ' : '';
    if (!p.length) { return gratis ? '<span class="an-regalo__envio">' + gratis + '</span>' : ''; }
    return '<span class="an-regalo__envio">' + gratis + 'Te faltan ' + p.join(' y ') + '.</span>';
  }
  function animaEscalera(el) {
    var m = el.querySelector('.an-mt');
    if (!m) { return; }
    // reflujo forzado en vez de requestAnimationFrame: en pestanas ocultas no corre
    void m.offsetWidth;
    m.style.setProperty('--ya', m.getAttribute('data-an-ya'));
  }
  // foto del regalo que ya esta en el carrito
  function fotoRegalo(el) {
    var t = el.querySelector('[data-an-regalo-foto]');
    if (!t) { return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var it = (c.items || []).filter(function (x) { return /100\s*%\s*off/i.test(x.product_title || x.title || ''); })[0];
      if (it && it.image) {
        var src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=96';
        t.innerHTML = '<img src="' + esc(src) + '" alt="" width="40" height="40">';
      }
    }).catch(function () {});
  }

  function animaMetas(el) {
    var m = el.querySelector('.an-metas__meta');
    if (!m) { return; }
    m.classList.add('an-ru__meta--ve');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        m.style.setProperty('--an-ru-ya', m.getAttribute('data-an-ya'));
      });
    });
  }

  // 31-oct-2026: tarjeta de regalos del carrito, la que aprobo Alejandro.
  // Una meta a la vez: lo ganado con chulo y debajo lo que sigue con su barra.
  // Al llegar al Charm, «Elige tu tono» abre los tonos con inventario.
  var CSS_GC =
    '.an-regalo.an-gc{display:block;background:#281220;color:#FFF8F0;border-radius:12px;padding:13px 14px;margin:0 0 12px;font-size:13px;line-height:18px}' +
    '.an-gc strong{color:#F6D9A4;font-weight:700}' +
    '.an-gc__ok{display:flex;align-items:center;gap:8px;margin:0 0 6px;color:#FFF8F0}' +
    '.an-gc__v{width:18px;height:18px;border-radius:9px;background:#F6D9A4;color:#281220;font-size:11px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;flex:none}' +
    '.an-gc__sig{display:block;margin-top:10px;color:#FFF8F0}' +
    '.an-gc__barra{display:block;height:6px;background:rgba(255,248,240,.18);border-radius:6px;margin-top:8px;overflow:hidden}' +
    '.an-gc__barra>span{display:block;height:100%;background:#F6D9A4;border-radius:6px}' +
    '.an-gc__luego{display:block;margin-top:9px;font-size:12px;opacity:.6;color:#FFF8F0}' +
    '.an-gc__btn{display:block;width:100%;margin-top:11px;background:#F6D9A4;color:#281220;border:0;border-radius:24px;padding:11px 10px;font-family:inherit;font-size:13px;font-weight:700;line-height:1.2;cursor:pointer}' +
    '.an-gc__tonos{display:grid;grid-template-columns:repeat(auto-fill,minmax(70px,1fr));gap:8px;margin-top:10px}' +
    '.an-gc__tono{display:flex;flex-direction:column;align-items:center;gap:4px;background:#FFF8F0;color:#281220;border:0;border-radius:10px;padding:8px 4px;font-family:inherit;font-size:11px;font-weight:600;line-height:1.2;cursor:pointer}' +
    '.an-gc__tono img{width:44px;height:44px;object-fit:contain;border-radius:6px}' +
    '.an-gc__tono:disabled{opacity:.6;cursor:default}';
  function estiloGc() {
    if (document.getElementById('an-gc-css')) { return; }
    var s = document.createElement('style');
    s.id = 'an-gc-css';
    s.textContent = CSS_GC;
    document.head.appendChild(s);
  }
  function filaOk(txt) {
    return '<span class="an-gc__ok"><span class="an-gc__v" aria-hidden="true">&#10003;</span><span>' + txt + '</span></span>';
  }
  // el tono del Charm que ya esta en el carrito, aunque despues se haya agotado
  function charmPuesto(charm, ids) {
    var lista = (window.fgData && window.fgData.offers) || [];
    for (var i = 0; i < lista.length; i++) {
      if (String(lista[i].id) !== charm.id) { continue; }
      var gp = lista[i].gift_products || [];
      for (var g = 0; g < gp.length; g++) {
        var vs = gp[g].variants || [];
        for (var k = 0; k < vs.length; k++) {
          if (vs[k].variant_shopify_id && ids.indexOf(',' + vs[k].variant_shopify_id + ',') > -1) {
            return { tono: String(vs[k].variant_title || vs[k].title || '').trim() };
          }
        }
      }
    }
    return null;
  }
  function pinta() {
    var vivas = ofertasVivas();
    var base = null, charm = null;
    for (var q = 0; q < vivas.length; q++) {
      if (vivas[q].min <= 100 && vivas[q].palabra === 'vela') { base = vivas[q]; }
      else if (vivas[q].min > 100 && vivas[q].palabra === 'Charm' && !charm) { charm = vivas[q]; }
    }
    if (!base) { pintaAntes(); return; }
    estiloGc();
    var todos = document.querySelectorAll('[data-an-regalo]');
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      var total = Number(el.getAttribute('data-an-total') || 0);
      var envio = Number(el.getAttribute('data-an-envio') || 19500000);
      var ids = el.getAttribute('data-an-regalo-ids') || ',';
      var abierto = el.getAttribute('data-an-abierto') === '1';
      var puesto = charm ? charmPuesto(charm, ids) : null;
      var firma = 'gc|' + total + '|' + envio + '|' + ids + '|' + (charm ? charm.id + ':' + charm.regalos.length : '') +
        '|' + abierto + '|' + (window.anFotosVer || 0);
      if (el.getAttribute('data-an-pintado') === firma) { continue; }
      el.setAttribute('data-an-pintado', firma);
      var metas = [{ v: envio, ok: 'Ya tienes envío gratis', falta: 'para el envío gratis' }];
      if (charm) { metas.push({ v: charm.min, ok: 'Ganaste un Charm de regalo', falta: 'para elegir tu Charm de regalo', charm: true }); }
      metas.sort(function (a, b) { return a.v - b.v; });
      var html = filaOk('Tu vela de cera de abeja va de regalo');
      var sig = null;
      for (var m = 0; m < metas.length; m++) {
        if (total >= metas[m].v) {
          html += metas[m].charm && puesto
            ? filaOk('Tu Charm' + (puesto.tono ? ' ' + esc(puesto.tono) : '') + ' va de regalo')
            : filaOk(metas[m].ok);
        } else if (!sig) { sig = metas[m]; }
      }
      if (sig) {
        html += '<span class="an-gc__sig">Te faltan <strong>' + pesos(sig.v - total) + '</strong> ' + sig.falta + '</span>' +
          '<span class="an-gc__barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
          Math.round(Math.min(100, total / sig.v * 100)) + '"><span style="width:' +
          Math.max(3, Math.min(100, total / sig.v * 100)).toFixed(1) + '%"></span></span>';
        var luego = null;
        for (var n = 0; n < metas.length; n++) { if (metas[n].v > sig.v) { luego = metas[n]; break; } }
        if (luego && luego.charm) { html += '<span class="an-gc__luego">Después sigue: un Charm de regalo</span>'; }
      }
      if (charm && total >= charm.min && !puesto) {
        html += '<button type="button" class="an-gc__btn" data-an-tono aria-expanded="' + abierto + '">Elige tu tono</button>';
        if (abierto) {
          html += '<span class="an-gc__tonos">' + charm.regalos.map(function (r) {
            return '<button type="button" class="an-gc__tono" data-an-elegir="' + esc(r.variante) + '">' +
              (r.img ? '<img src="' + esc(r.img) + '" alt="" width="44" height="44" loading="lazy">' : '') +
              '<span>' + esc(r.corto) + '</span></button>';
          }).join('') + '</span>';
        }
      }
      el.classList.remove('an-regalo--elige', 'an-regalo--listo');
      el.classList.add('an-metas', 'an-gc');
      el.innerHTML = html;
      el.hidden = false;
    }
  }
  // «Elige tu tono» muestra los tonos con inventario dentro de la tarjeta
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-an-tono]');
    if (!b) { return; }
    ev.preventDefault();
    var host = b.closest('[data-an-regalo]');
    if (!host) { return; }
    host.setAttribute('data-an-abierto', host.getAttribute('data-an-abierto') === '1' ? '' : '1');
    agenda();
  });

  function pintaAntes() {
    // en plural: el cajon y la pagina del carrito pueden pintar los dos
    var todos = document.querySelectorAll('[data-an-regalo]');
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      var total = Number(el.getAttribute('data-an-total') || 0);
      var escalon = ofertaPara(total);
      var oferta = escalon.oferta;
      var siguiente = escalon.siguiente;
      // si BOGOS ya metio el regalo, no se hacen cuentas
      var puesto = el.getAttribute('data-an-regalo-puesto') === 'true';
      // 31-oct-2026: la vela de cualquier compra no cuenta como el Charm puesto
      var ids = el.getAttribute('data-an-regalo-ids');
      if (oferta && ids !== null) {
        puesto = oferta.regalos.some(function (r) { return r.variante && ids.indexOf(',' + r.variante + ',') > -1; });
      }
      // el regalo de cualquier compra, si no es la oferta que toca
      var vivas = ofertasVivas(), base = null;
      for (var b0 = 0; b0 < vivas.length; b0++) {
        if (vivas[b0].min <= 100 && (!oferta || vivas[b0].id !== oferta.id)) { base = vivas[b0]; }
      }
      var lineaBase = base ? '<span class="an-regalo__cab">Tu <strong>' + esc(base.nombre) + '</strong> va de regalo.</span>' : '';
      var envio = Number(el.getAttribute('data-an-envio') || 19500000);
      var firma = total + '|' + puesto + '|' + envio + '|' +
        (oferta ? oferta.id + '|' + oferta.min + '|' + oferta.nombre + '|' + oferta.varios : 'sin') +
        '|' + (siguiente ? siguiente.id : '') + '|' + (window.anFotosVer || 0);
      // sin esta firma el observador se dispara con su propio cambio y no para
      if (el.getAttribute('data-an-pintado') === firma) { continue; }
      el.setAttribute('data-an-pintado', firma);
      el.classList.remove('an-gc');
      el.classList.add('an-metas');
      var lineaEnvio = total >= envio
        ? '<span class="an-regalo__envio">Tu <strong>envío es gratis</strong>.</span>'
        : '<span class="an-regalo__envio">Te faltan <strong>' + pesos(envio - total) + '</strong> para el envío gratis.</span>';
      if (!oferta) {
        // sin campana la barra queda con una sola meta: el envio gratis
        el.classList.remove('an-regalo--elige', 'an-regalo--listo');
        if (total >= envio) { el.textContent = ''; el.hidden = true; continue; }
        el.innerHTML = '<span class="an-regalo__cab">Te faltan <strong>' + pesos(envio - total) +
          '</strong> para el envío gratis.</span>' + barraMetas(total, 0, envio);
        el.hidden = false;
        animaMetas(el);
        continue;
      }
      var listo = !puesto && total >= oferta.min;
      el.classList.toggle('an-regalo--elige', !!oferta.varios && !puesto);
      el.classList.toggle('an-regalo--listo', !!oferta.varios && listo);
      if (oferta.varios) {
        var cab, extra = '';
        if (puesto) {
          cab = '<span class="an-regalo__foto" data-an-regalo-foto></span>' + (oferta.palabra === 'regalo' ? 'Tu regalo va incluido.' : 'Tu ' + oferta.palabra + ' de regalo va incluido.');
          extra = lineaEnvio;
          // 20-oct-2026: con el regalo ya puesto tambien se dice el siguiente
          if (siguiente) {
            extra += '<span class="an-regalo__envio">Te faltan <strong>' + pesos(siguiente.min - total) +
              '</strong> para desbloquear tu siguiente regalo: ' + esc(siguiente.cuales) + '.</span>';
          }
        } else if (listo) {
          cab = oferta.palabra === 'regalo' ? '<strong>Ganaste un regalo.</strong> Elige el tuyo:'
            : '<strong>Ganaste un ' + oferta.palabra + ' de regalo.</strong> Elige el tuyo:';
          extra = lineaEnvio;
          // 20-oct-2026: si hay un escalon mas arriba, se dice cuanto falta
          if (siguiente) {
            extra += '<span class="an-regalo__envio">Te faltan <strong>' + pesos(siguiente.min - total) +
              '</strong> para desbloquear tu siguiente regalo: ' + esc(siguiente.cuales) + '.</span>';
          }
        } else {
          // 20-oct-2026: antes del umbral, una sola frase; las fotos salen al desbloquear
          cab = 'Te faltan <strong>' + pesos(oferta.min - total) + '</strong> para elegir tu ' +
            (oferta.palabra === 'regalo' ? 'regalo' : oferta.palabra + ' de regalo') +
            (total < envio && envio > oferta.min ? ' y <strong>' + pesos(envio - total) + '</strong> para el envío gratis' : '') + '.';
        }
        var todoListo = total >= envio && (puesto || listo) && !siguiente;
        var barra = todoListo ? logros(oferta, total, envio)
          : metasEscalera(total, envio) + (puesto || listo ? lineaFaltan(total, envio, siguiente, true) : '');
        var fila = '', pie = '';
        if (!puesto && listo) {
          fila = '<span class="an-regalo__fila">' + oferta.regalos.map(function (r) {
            var boton = listo && r.variante
              ? '<button type="button" class="an-regalo__elegir" data-an-elegir="' + esc(r.variante) + '">Elegir</button>'
              : '';
            return '<span class="an-regalo__it">' +
              (r.img ? '<img src="' + esc(r.img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
              '<span class="an-regalo__nom">' + esc(r.corto) + '</span>' +
              (r.ml ? '<span class="an-regalo__ml">' + esc(r.ml) + '</span>' : '') +
              boton + '</span>';
          }).join('') + '</span>';
          var hasta = '';
          try {
            hasta = new Date(oferta.fin - 60000).toLocaleDateString('es-CO',
              { weekday: 'long', day: 'numeric', timeZone: 'America/Bogota' }).replace(',', '');
          } catch (e) { hasta = ''; }
          // 20-oct-2026: antes del umbral se dice cuando se puede elegir
          pie = '<span class="an-regalo__pie">Eliges 1 de los ' + oferta.regalos.length +
            (listo ? '' : ' al llegar a ' + pesos(oferta.min)) +
            (hasta ? '. Hasta el ' + esc(hasta) + '.' : '.') + '</span>';
        }
        el.innerHTML = lineaBase + '<span class="an-regalo__cab">' + cab + '</span>' + barra + fila + pie;
        el.hidden = false;
        animaMetas(el);
        animaEscalera(el);
        if (puesto) { fotoRegalo(el); }
        continue;
      }
      // 31-oct-2026: regalo sin elegir (la vela): se dice y se muestra lo que sigue
      var gano = puesto || total >= oferta.min;
      var cab1 = gano ? 'Tu <strong>' + esc(oferta.nombre) + '</strong> va de regalo.'
        : 'Te faltan <strong>' + pesos(oferta.min - total) + '</strong> y se suma tu regalo: ' + esc(oferta.nombre) + '.';
      var faltan = [];
      if (total < envio) { faltan.push('<strong>' + pesos(envio - total) + '</strong> para el envío gratis'); }
      if (siguiente) { faltan.push('<strong>' + pesos(siguiente.min - total) + '</strong> para elegir ' + esc(siguiente.un) + ' de regalo'); }
      var gratis1 = total >= envio ? 'Tu <strong>envío es gratis</strong>. ' : '';
      var linea2 = faltan.length ? '<span class="an-regalo__envio">' + gratis1 + 'Te faltan ' + faltan.join(' y ') + '.</span>'
        : (gratis1 ? '<span class="an-regalo__envio">' + gratis1 + '</span>' : '');
      el.classList.remove('an-regalo--elige', 'an-regalo--listo');
      el.innerHTML = '<span class="an-regalo__cab">' + cab1 + '</span>' +
        (faltan.length ? metasEscalera(total, envio) : '') + linea2;
      el.hidden = false;
      animaEscalera(el);
    }
  }

  // Elegir: agrega al carrito la variante de regalo que creo BOGOS (precio 0)
  // y pide al tema que vuelva a pintar el cajon. BOGOS sigue siendo quien
  // valida en el checkout que el regalo corresponde.
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-an-elegir]');
    if (!b || b.disabled) { return; }
    ev.preventDefault();
    // Se agrega con la funcion de BOGOS, la misma de su boton «Agregar»: si
    // se usa /cart/add.js, BOGOS lo quita. Su ventana no sirve de respaldo
    // fijo porque, si la clienta la cerro, no se vuelve a abrir.
    var app = window.FGSECOMAPP;
    var v = String(b.getAttribute('data-an-elegir'));
    var oferta = null;
    ((app && app.offers) || []).forEach(function (o) {
      (o.gift_products || []).forEach(function (p) {
        (p.variants || []).forEach(function (x) {
          if (String(x.variant_shopify_id) === v) { oferta = o; }
        });
      });
    });
    if (!oferta || !app.helper || !app.helper.addGiftToCart) {
      window.anSliderPedido = Date.now(); document.dispatchEvent(new CustomEvent('fg-gifts:show-slider'));
      return;
    }
    var todos = document.querySelectorAll('[data-an-elegir]');
    for (var i = 0; i < todos.length; i++) { todos[i].disabled = true; }
    if (b.classList.contains('an-gc__tono')) { b.setAttribute('aria-busy', 'true'); } else { b.textContent = 'Agregando'; }
    Promise.resolve(app.helper.addGiftToCart(Number(v), 1, String(oferta.id)))
      .then(function (ok) { if (!ok) { throw new Error('no'); } })
      .catch(function () {
        window.anSliderPedido = Date.now(); document.dispatchEvent(new CustomEvent('fg-gifts:show-slider'));
      })
      .then(function () {
        // 31-oct-2026: en /cart la pagina no se repinta sola; se recarga
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        for (var j = 0; j < todos.length; j++) { todos[j].disabled = false; }
        if (!b.classList.contains('an-gc__tono')) { b.textContent = 'Elegir'; }
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  });

  // BOGOS agrega el regalo pero deja su ventana abierta y no repinta el
  // cajon: parecia que no habia pasado nada. Se cierra y se repinta.
  document.addEventListener('fg-gifts:added', function () {
    setTimeout(function () {
      var x = document.querySelector('.sca-is-visible-fg .bogos-slider-close-btn');
      if (x) { x.click(); }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }, 350);
  });

  var espera = null;
  function agenda() {
    clearTimeout(espera);
    espera = setTimeout(pinta, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agenda);
  } else {
    agenda();
  }
  // el cajon se clona de un <template>, asi que se vigila el documento entero
  new MutationObserver(agenda).observe(document.documentElement,
                                       { childList: true, subtree: true });
  // fgData puede llegar despues del primer pintado y sin tocar el DOM
  [600, 1800, 4000].forEach(function (t) { setTimeout(agenda, t); });
})();


/* La barra de anuncios.
 *
 * Un solo mensaje. Por defecto, el envio gratis con la cifra del ajuste del
 * tema (se lee de data-limit del cajon). Mientras BOGOS tenga una oferta viva,
 * el mensaje pasa a ser el regalo, con el umbral y el nombre que da BOGOS; al
 * cerrar la campana vuelve solo al envio, aunque la pagina siga abierta.
 */
(function () {
  'use strict';
  if (window.anBarraRegalo) { return; }
  window.anBarraRegalo = 1;

  function pesos(n) {
    return '$' + Math.round(n).toLocaleString('es-CO').replace(/,/g, '.');
  }

  function envio() {
    var c = document.querySelector('[data-cart-message][data-limit]');
    var lim = c ? parseFloat(c.getAttribute('data-limit')) : 0;
    return lim ? 'Envío gratis desde ' + pesos(lim) : '';
  }

  // 31-oct-2026: la barra dice lo que la clienta ya gano y lo que le falta
  var CARRO = null;
  function leeCarro() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CARRO = c; pinta(); })
      .catch(function () {});
  }
  function escalera(todas) {
    var base = null, meta = null;
    for (var i = 0; i < todas.length; i++) {
      if (todas[i].min <= 100) { if (!base) { base = todas[i]; } } else if (!meta) { meta = todas[i]; }
    }
    if (!base) { return ''; }
    // el umbral del envio: el que pinta el carrito (centavos) o el del cajon
    var r = document.querySelector('[data-an-regalo][data-an-envio]');
    var c = document.querySelector('[data-cart-message][data-limit]');
    var lim = r ? (parseFloat(r.getAttribute('data-an-envio')) || 0) / 100
      : c ? parseFloat(c.getAttribute('data-limit')) || 0 : 195000;
    var total = CARRO ? (CARRO.total_price || 0) / 100 : 0;
    // en el celular la barra es de una linea: frases cortas
    var cel = window.innerWidth < 750;
    if (!meta) { return 'Con toda compra te llevas ' + base.un + '.'; }
    if (total <= 0) {
      return cel ? base.palabra.charAt(0).toUpperCase() + base.palabra.slice(1) + ' gratis en toda compra. ' + meta.palabra + ' desde ' + pesos(meta.min / 100)
        : 'Con toda compra te llevas ' + base.un + '. Desde ' + pesos(meta.min / 100) + ' eliges además ' + meta.un + '.';
    }
    var metas = [];
    if (lim) { metas.push({ v: lim, txt: 'el envío gratis' }); }
    metas.push({ v: meta.min / 100, txt: 'elegir tu ' + meta.palabra + ' de regalo', meta: true });
    metas.sort(function (a, b) { return a.v - b.v; });
    var sig = null;
    for (var k = 0; k < metas.length; k++) { if (metas[k].v > total) { sig = metas[k]; break; } }
    if (sig) {
      if (cel) { return 'Te faltan ' + pesos(sig.v - total) + ' para ' + sig.txt; }
      var antes = sig.meta && lim && total >= lim ? 'Ya tienes envío gratis. ' : 'Tu ' + base.palabra + ' ya va de regalo. ';
      return antes + 'Te faltan ' + pesos(sig.v - total) + ' para ' + sig.txt + '.';
    }
    var ids = (CARRO.items || []).map(function (x) { return String(x.variant_id); });
    var puesto = meta.regalos.some(function (r) { return ids.indexOf(String(r.variante)) > -1; });
    if (cel) { return puesto ? 'Tu ' + base.palabra + ' y tu ' + meta.palabra + ' van de regalo' : 'Ganaste ' + meta.un + '. Elígelo en tu carrito'; }
    return puesto ? 'Tu ' + base.palabra + ' y tu ' + meta.palabra + ' van de regalo, y el envío es gratis.'
      : 'Ganaste ' + meta.un + ' de regalo. Elígelo en tu carrito.';
  }

  function pinta() {
    var oferta = window.anOfertaViva ? window.anOfertaViva() : null;
    var texto = !oferta ? envio()
      // 28-oct-2026: con minimo de $1 la oferta es para cualquier compra (Alejandro)
      : oferta.varios
        ? (oferta.min <= 100 ? 'Con toda compra' : 'Desde ' + pesos(oferta.min / 100)) + ' eliges tu ' + oferta.palabra + ' de regalo'
        : (oferta.min <= 100 ? 'Con toda compra' : 'Desde ' + pesos(oferta.min / 100)) + ' te llevas ' + oferta.un + ' de regalo';
    // 20-oct-2026: con varios escalones vivos se anuncia la escalera
    var todas = window.anOfertasVivas ? window.anOfertasVivas() : [];
    var conBase = escalera(todas);
    if (conBase) {
      texto = conBase;
    } else if (todas.length > 1) {
      texto = 'Más compra, mejor regalo desde ' + pesos(todas[0].min / 100) + ': ' +
        todas.map(function (t) {
          return t.palabra === 'regalo' ? t.cuales.split(' o ')[0].split(' ')[0] : t.palabra;
        }).join(', ').replace(/, ([^,]*)$/, ' o $1');
    }
    var promo = window.anPromoViva ? window.anPromoViva() : null;
    if (promo && promo.barra) { texto = promo.barra; }
    if (!texto) { return; }
    var els = document.querySelectorAll('[data-an-barra]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== texto) { els[i].textContent = texto; }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinta);
  } else {
    pinta();
  }
  // fgData llega entre 3 y 8 segundos despues; se revisa cada minuto para que
  // el cambio de fecha (inicio o cierre) se note sin recargar
  [1000, 3000, 6000, 9000, 15000].forEach(function (t) { setTimeout(pinta, t); });
  setInterval(pinta, 60000);
  leeCarro();
  // cada vez que el carrito cambia (el cajon repinta data-an-total) se relee
  var ultimoTotal = null;
  new MutationObserver(function () {
    var e = document.querySelector('[data-an-regalo][data-an-total]');
    var v = e ? e.getAttribute('data-an-total') + '|' + e.getAttribute('data-an-regalo-ids') : null;
    if (v !== null && v !== ultimoTotal) { ultimoTotal = v; leeCarro(); }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-an-total', 'data-an-regalo-ids'] });
  ['cart:refresh', 'theme:cart:refresh', 'fg-gifts:added'].forEach(function (n) {
    document.addEventListener(n, function () { setTimeout(leeCarro, 600); });
  });
})();


/* Las sugerencias del carrito no venden lo que se esta regalando. 12-oct-2026.
 * Mientras BOGOS tenga una oferta viva, cualquier sugerencia del carrito cuyo
 * enlace apunte a uno de los productos de regalo se oculta. Fuera de fechas no
 * hace nada.
 */
(function () {
  'use strict';
  if (window.anOcultaRegalos) { return; }
  window.anOcultaRegalos = 1;

  function pinta() {
    var o = window.anOfertaViva ? window.anOfertaViva() : null;
    var hs = (o && o.handles) || [];
    var zonas = document.querySelectorAll('.an-va--carrito, [data-pair-products-holder], [data-upsell-holder]');
    document.querySelectorAll('.an-va--carrito').forEach(function (e) { e.classList.add('an-va--js'); });
    for (var z = 0; z < zonas.length; z++) {
      var links = zonas[z].querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var m = links[i].getAttribute('href').match(/\/products\/([^/?#]+)/);
        var h = m ? m[1] : '';
        var tarjeta = links[i].closest('.an-va__it, [data-upsell-item]');
        if (!tarjeta) { continue; }
        var oculta = hs.indexOf(h) > -1;
        if (oculta && !tarjeta.getAttribute('data-an-oculto-regalo')) { tarjeta.style.display = 'none'; tarjeta.setAttribute('data-an-oculto-regalo', '1'); }
        if (!oculta && tarjeta.getAttribute('data-an-oculto-regalo')) { tarjeta.style.display = ''; tarjeta.removeAttribute('data-an-oculto-regalo'); }
      }
      // se ven las 3 primeras que no son regalo; si no queda ninguna, el
      // titular tampoco, para que no quede «Estos completan tu rutina:» solo
      var vistas = 0;
      var cards = zonas[z].querySelectorAll('.an-va__it');
      var pasos = {};
      for (var k = 0; k < cards.length; k++) {
        var tp = cards[k].getAttribute('data-an-tipo') || '';
        var ve = !cards[k].getAttribute('data-an-oculto-regalo') && vistas < 3 && !(tp && pasos[tp]);
        cards[k].classList.toggle('an-va__it--ve', ve);
        if (ve) { vistas += 1; if (tp) { pasos[tp] = 1; } }
      }
      var tit = zonas[z].previousElementSibling;
      if (tit && tit.classList.contains('an-completa-envio')) { tit.hidden = vistas === 0; }
    }
  }

  var espera = null;
  function agenda() { clearTimeout(espera); espera = setTimeout(pinta, 120); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agenda);
  } else { agenda(); }
  new MutationObserver(agenda).observe(document.documentElement, { childList: true, subtree: true });
  [600, 1800, 4000].forEach(function (t) { setTimeout(agenda, t); });
})();


/* La meta mas cercana. 12-oct-2026.
 * Con regalo vivo en BOGOS y el carrito por debajo de su monto, las
 * sugerencias del carrito hablan del regalo, que suele estar mas cerca que el
 * envio gratis. Fuera de campana no toca nada.
 */
(function () {
  'use strict';
  if (window.anMetaCercana) { return; }
  window.anMetaCercana = 1;

  function num(t) { return Number(String(t || '').replace(/[^\d]/g, '')) || 0; }
  function pesos(n) { return '$' + Math.round(n).toLocaleString('es-CO').replace(/,/g, '.'); }

  function pinta() {
    var o = window.anOfertaViva ? window.anOfertaViva() : null;
    if (!o) { return; }
    var cabs = document.querySelectorAll('.an-completa-envio');
    for (var i = 0; i < cabs.length; i++) {
      var cab = cabs[i];
      if (cab.getAttribute('data-an-meta')) { continue; }
      if (cab.classList.contains('an-completa-rutina')) { continue; }
      var raiz = cab.closest('[data-cart-drawer], #cart-drawer, form, .cart') || document;
      var reg = raiz.querySelector('[data-an-regalo]') || document.querySelector('[data-an-regalo]');
      if (!reg) { continue; }
      var total = Number(reg.getAttribute('data-an-total') || 0);
      var puesto = reg.getAttribute('data-an-regalo-puesto') === 'true';
      if (puesto || total >= o.min) { continue; }
      var falta = (o.min - total) / 100;
      var zona = cab.parentElement && cab.parentElement.querySelector('.an-va');
      if (!zona) { continue; }
      var cards = [].slice.call(zona.querySelectorAll('.an-va__it')).filter(function (c) {
        return !c.getAttribute('data-an-oculto-regalo');
      });
      var alcanzan = cards.filter(function (c) {
        var p = c.querySelector('[data-an-va-precio]');
        return p && num(p.textContent) >= falta;
      });
      if (!alcanzan.length) { continue; }
      cab.setAttribute('data-an-meta', '1');
      var palabra = o.palabra || 'regalo';
      if (/ya lo cierras/.test(cab.textContent)) {
        cab.innerHTML = 'Con uno de estos llegas a tu <strong>' + palabra +
          ' de regalo</strong> y al envío gratis:';
      } else {
        cab.innerHTML = 'Te faltan <strong>' + pesos(falta) + '</strong> para tu ' +
          palabra + ' de regalo. Con uno de estos llegas:';
        for (var k = alcanzan.length - 1; k >= 0; k--) {
          zona.insertBefore(alcanzan[k], zona.firstChild);
        }
      }
    }
  }

  var espera = null;
  function agenda() { clearTimeout(espera); espera = setTimeout(pinta, 150); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agenda);
  } else { agenda(); }
  new MutationObserver(agenda).observe(document.documentElement, { childList: true, subtree: true });
  [700, 2000, 4500].forEach(function (t) { setTimeout(agenda, t); });
})();


/* Escalera de descuento: banda del home, linea de la ficha y nivel del carrito.
 * 16-oct-2026. Todo sale de window.anPromo; fuera de fechas se esconde.
 * El carrito trae en data-an-elig el monto (en centavos) de los productos que
 * participan: sin kits, sin regalos de $0 y sin precio rebajado.
 */
(function () {
  'use strict';
  if (window.anEscalera) { return; }
  window.anEscalera = 1;

  function pesos(n) {
    return '$' + Math.round(n).toLocaleString('es-CO').replace(/,/g, '.');
  }

  function nivel(p, monto) {
    var act = null, sig = null;
    for (var i = 0; i < p.niveles.length; i++) {
      var n = p.niveles[i];
      if (monto >= n[0]) { act = n; } else if (!sig) { sig = n; }
    }
    return { act: act, sig: sig };
  }

  function pinta() {
    var p = window.anPromoViva ? window.anPromoViva() : null;
    var bloques = document.querySelectorAll('[data-an-promo]');
    for (var i = 0; i < bloques.length; i++) {
      var b = bloques[i], tipo = b.getAttribute('data-an-promo');
      if (!p) { b.hidden = true; continue; }
      if (tipo === 'ficha') {
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
        if (meta && String(meta.type || '').toUpperCase() === 'KIT') { b.hidden = true; continue; }
        if (b.textContent !== p.ficha) { b.textContent = p.ficha; }
      } else if (tipo === 'banda') {
        var campos = b.querySelectorAll('[data-an-promo-campo]');
        for (var c = 0; c < campos.length; c++) {
          var k = campos[c].getAttribute('data-an-promo-campo');
          if (campos[c].textContent !== p[k]) { campos[c].textContent = p[k] || ''; }
          if (k === 'boton') { campos[c].setAttribute('href', p.url || '/'); }
        }
      }
      b.hidden = false;
    }
    var es = document.querySelectorAll('[data-an-escalera]');
    for (var j = 0; j < es.length; j++) {
      var e = es[j];
      if (!p) { e.hidden = true; continue; }
      var monto = Number(e.getAttribute('data-an-elig') || 0) / 100;
      var t;
      if (monto <= 0) {
        t = p.kits;
      } else {
        var r = nivel(p, monto);
        if (r.act && r.sig) {
          t = 'Llevas ' + r.act[1] + '% de descuento. Te faltan ' + pesos(r.sig[0] - monto) + ' para el ' + r.sig[1] + '%.';
        } else if (r.act) {
          t = 'Tienes el ' + r.act[1] + '% de descuento, el nivel más alto.';
        } else {
          t = '';
        }
      }
      if (e.textContent !== t) { e.textContent = t; }
      e.hidden = !t;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinta);
  } else {
    pinta();
  }
  new MutationObserver(function () { pinta(); })
    .observe(document.documentElement, { childList: true, subtree: true });
  setInterval(pinta, 60000);
})();

/* Escalera animada del home. 16-oct-2026.
 * Arma los escalones con window.anPromo.niveles cuando la promocion esta viva,
 * los anima al entrar en pantalla y muestra el monto de cada nivel al tocarlo o
 * pasar el mouse. Sin promocion viva no hace nada (la seccion sigue oculta).
 */
(function () {
  'use strict';
  if (window.anEscaleraHome) { return; }
  window.anEscaleraHome = 1;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finoHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function pesos(n) { return '$' + Math.round(n).toLocaleString('es-CO').replace(/,/g, '.'); }
  function corto(n) {
    if (n <= 1) { return 'Toda compra'; }
    if (n >= 1000000) { return n === 1000000 ? '$1 millón' : '$' + String(n / 1000000).replace('.', ',') + ' millones'; }
    return '$' + (n / 1000) + ' mil';
  }
  function pie(n) {
    return n[0] <= 1 ? 'En toda compra: ' + n[1] + '% de descuento.'
                     : 'Desde ' + pesos(n[0]) + ': ' + n[1] + '% de descuento.';
  }

  function cuenta(el, fin, espera) {
    if (reduce) { el.textContent = fin + '%'; return; }
    el.textContent = '0%';
    setTimeout(function () {
      var t0 = null, dur = 700;
      function paso(t) {
        if (t0 === null) { t0 = t; }
        var k = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(fin * e) + '%';
        if (k < 1) { requestAnimationFrame(paso); }
      }
      requestAnimationFrame(paso);
    }, espera);
  }

  function arma(sec, p) {
    if (sec.getAttribute('data-an-esc-hecho')) { return; }
    sec.setAttribute('data-an-esc-hecho', '1');
    var campos = sec.querySelectorAll('[data-an-esc-campo]');
    for (var c = 0; c < campos.length; c++) {
      var k = campos[c].getAttribute('data-an-esc-campo');
      campos[c].textContent = p[k] || '';
      if (k === 'boton') { campos[c].setAttribute('href', p.url || '/'); }
      if (!p[k]) { campos[c].hidden = true; }
    }
    var cont = sec.querySelector('[data-an-esc-barras]');
    var cap = sec.querySelector('[data-an-esc-cap]');
    var niv = p.niveles || [];
    var tocado = false;
    var pasos = [];
    niv.forEach(function (n, i) {
      var alto = 7 + 45 * i / Math.max(1, niv.length - 1);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'an-esc__paso';
      b.setAttribute('role', 'listitem');
      b.setAttribute('aria-label', pie(n));
      b.style.setProperty('--i', i);
      b.innerHTML = '<span class="an-esc__num">' + n[1] + '%</span>' +
                    '<span class="an-esc__barra" style="height:' + alto.toFixed(1) + '%"></span>' +
                    '';
      b.querySelector('.an-esc__barra').style.setProperty('--i', i);
      b.querySelector('.an-esc__num').style.setProperty('--i', i);
      if (i === niv.length - 1 && sec.getAttribute('data-an-esc-img')) {
        var im = document.createElement('img');
        im.className = 'an-esc__premio';
        im.src = sec.getAttribute('data-an-esc-img');
        im.alt = 'Suero Multipéptidos ÁNIMUS';
        im.width = 240; im.height = 720;
        im.style.setProperty('--i', i);
        b.insertBefore(im, b.firstChild);
      }
      cont.appendChild(b);
      pasos.push(b);
      function elige(manual) {
        if (manual) { tocado = true; }
        pasos.forEach(function (x) { x.classList.toggle('sel', x === b); });
        cont.classList.add('tiene-sel');
        cap.textContent = p.invita || 'Suma productos a tu carrito y sube de nivel.';
      }
      b.addEventListener('click', function () { elige(true); });
      b.addEventListener('focus', function () { elige(true); });
      if (finoHover) { b.addEventListener('mouseenter', function () { elige(true); }); }
      b._elige = elige;
    });
    if (finoHover) {
      cont.addEventListener('mouseleave', function () {
        cont.classList.remove('tiene-sel');
        pasos.forEach(function (x) { x.classList.remove('sel'); });
      });
    }
    function entra() {
      if (sec.classList.contains('is-in')) { return; }
      sec.classList.add('is-in');
      pasos.forEach(function (b, i) { cuenta(b.querySelector('.an-esc__num'), niv[i][1], reduce ? 0 : i * 70 + 300); });
      // el nivel clave (20%) queda elegido al terminar, salvo que la clienta ya haya tocado uno
      var clave = pasos.length - 1;
      setTimeout(function () { if (!tocado && pasos[clave]) { pasos[clave]._elige(false); } }, reduce ? 0 : 1500);
    }
    // Arranca al verse. Respaldo: si al cargar ya esta a la vista, o en todo caso
    // a los 1,5 s, arranca igual; nunca se queda un bloque negro vacio.
    function aLaVista() {
      var r = sec.getBoundingClientRect();
      return r.top < window.innerHeight * 0.85 && r.bottom > 0;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { entra(); io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(sec);
    }
    requestAnimationFrame(function () { if (aLaVista()) { entra(); } });
    window.addEventListener('scroll', function () { if (aLaVista()) { entra(); } }, { passive: true });
    setTimeout(entra, 1500);
  }

  function revisa() {
    var p = window.anPromoViva ? window.anPromoViva() : null;
    var secs = document.querySelectorAll('[data-an-esc]');
    for (var i = 0; i < secs.length; i++) {
      if (!p) { secs[i].hidden = true; continue; }
      secs[i].hidden = false;
      arma(secs[i], p);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', revisa); } else { revisa(); }
  setInterval(revisa, 60000);
})();

/* Empuje de la escalera. 16-oct-2026.
 * Bajo la linea de nivel del carrito ofrece el suero de 10 ml mas barato que
 * alcanza para subir al siguiente nivel. Si ninguno alcanza, no ofrece nada.
 * Opciones en window.anPromo.empuje; fuera de la promocion no hace nada.
 */
(function () {
  'use strict';
  if (window.anEmpuje) { return; }
  window.anEmpuje = 1;

  function pesos(n) { return '$' + Math.round(n).toLocaleString('es-CO').replace(/,/g, '.'); }

  function siguiente(p, monto) {
    for (var i = 0; i < p.niveles.length; i++) {
      if (monto < p.niveles[i][0]) { return p.niveles[i]; }
    }
    return null;
  }

  function pinta() {
    var p = window.anPromoViva ? window.anPromoViva() : null;
    var lineas = document.querySelectorAll('[data-an-escalera]');
    for (var i = 0; i < lineas.length; i++) {
      var e = lineas[i];
      var b = e.nextElementSibling && e.nextElementSibling.hasAttribute('data-an-empuje') ? e.nextElementSibling : null;
      var monto = Number(e.getAttribute('data-an-elig') || 0) / 100;
      var sig = p && p.empuje && monto > 0 ? siguiente(p, monto) : null;
      var falta = sig ? sig[0] - monto : 0;
      var op = null;
      if (sig && !e.hidden) {
        var ops = p.empuje.slice().sort(function (a, c) { return a.p - c.p; });
        for (var k = 0; k < ops.length; k++) { if (ops[k].p >= falta) { op = ops[k]; break; } }
      }
      if (!op) { if (b) { b.remove(); } continue; }
      var texto = 'Suma ' + op.n + ' (' + pesos(op.p) + ') y sube al ' + sig[1] + '%';
      if (!b) {
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'an-empuje';
        b.setAttribute('data-an-empuje', '');
        e.parentNode.insertBefore(b, e.nextSibling);
        b.addEventListener('click', agrega);
      }
      if (b.getAttribute('data-ocupado')) { continue; }
      b.setAttribute('data-v', op.v);
      if (b.textContent !== texto) { b.textContent = texto; }
    }
  }

  function agrega(ev) {
    var b = ev.currentTarget;
    if (b.getAttribute('data-ocupado')) { return; }
    b.setAttribute('data-ocupado', '1');
    b.disabled = true;
    b.textContent = 'Agregando';
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-v')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('no se pudo agregar'); }
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      b.remove();
    }).catch(function () {
      b.removeAttribute('data-ocupado');
      b.disabled = false;
      b.textContent = 'No se pudo agregar. Intenta de nuevo';
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pinta); } else { pinta(); }
  new MutationObserver(function () { pinta(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Aviso de regalo desbloqueado. 20-oct-2026.
 * Cuando el total del carrito entra a un escalon nuevo de BOGOS, sale un aviso
 * abajo con el regalo ganado y lo que falta para el siguiente. Una vez por
 * escalon y por sesion. Reemplaza la ventana generica de BOGOS.
 */
(function () {
  'use strict';
  if (window.anAvisoRegalo) { return; }
  window.anAvisoRegalo = 1;

  var CLAVE = 'anRegaloVisto';
  function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO').replace(/,/g, '.'); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function visto(id) {
    try { return (sessionStorage.getItem(CLAVE) || '').split('|').indexOf(id) > -1; } catch (e) { return false; }
  }
  function marca(id) {
    try {
      var l = (sessionStorage.getItem(CLAVE) || '').split('|').filter(Boolean);
      l.push(id); sessionStorage.setItem(CLAVE, l.join('|'));
    } catch (e) {}
  }

  var caja = null, reloj = null;
  function cierra() {
    if (!caja) { return; }
    caja.classList.remove('is-visible');
    clearTimeout(reloj);
  }

  function muestra(o, sig, todas, total) {
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'an-aviso';
      caja.setAttribute('role', 'status');
      caja.setAttribute('aria-live', 'polite');
      document.body.appendChild(caja);
      caja.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-an-aviso-x]')) { cierra(); }
        var ir = ev.target.closest('[data-an-aviso-ir]');
        if (ir) {
          var linea = document.querySelector('[data-an-regalo]:not([hidden])');
          if (linea && linea.offsetParent) {
            ev.preventDefault();
            linea.scrollIntoView({ behavior: 'smooth', block: 'center' });
            cierra();
          }
        }
      });
      caja.addEventListener('pointerenter', function () { clearTimeout(reloj); });
      caja.addEventListener('pointerleave', function () { reloj = setTimeout(cierra, 4000); });
    }
    var que = o.palabra === 'regalo' ? 'tu regalo' : 'tu ' + esc(o.palabra) + ' de regalo';
    var detalle = o.palabra === 'regalo' ? '<span class="an-aviso__det">' + esc(o.cuales) + '.</span>' : '';
    var siguiente = sig
      ? '<span class="an-aviso__sig">Te faltan <strong>' + pesos(sig.min - total) +
        '</strong> para desbloquear tu siguiente regalo: ' + esc(sig.cuales) + '.</span>'
      : (todas.length > 1 ? '<span class="an-aviso__sig">Llegaste al regalo más alto.</span>' : '');
    var escalera = '';
    if (todas.length > 1) {
      escalera = '<span class="an-aviso__esc" aria-hidden="true">' + todas.map(function (t) {
        var on = t.min <= o.min;
        var nom = t.palabra === 'regalo' ? t.cuales.split(' o ').map(function (x) { return x.split(' ')[0]; }).join(' o ')
          : t.palabra === 'suero' ? 'Suero 10 ml' : t.palabra.charAt(0).toUpperCase() + t.palabra.slice(1);
        return '<span class="an-aviso__paso' + (on ? ' is-on' : '') + '"><span class="an-aviso__raya"></span>' +
          esc(nom) + '</span>';
      }).join('') + '</span>';
    }
    caja.innerHTML =
      '<button type="button" class="an-aviso__x" data-an-aviso-x aria-label="Cerrar">&times;</button>' +
      '<span class="an-aviso__tit">Desbloqueaste ' + que + '.</span>' + detalle + escalera + siguiente +
      '<a class="an-aviso__btn" href="/cart" data-an-aviso-ir>' +
      (o.varios ? 'Elegir mi ' + (o.palabra === 'regalo' || o.palabra === 'suero' ? 'regalo' : esc(o.palabra)) : 'Ver mi carrito') + '</a>';
    // se fuerza el pintado del estado inicial y luego se anima
    caja.classList.remove('is-visible');
    void caja.offsetHeight;
    caja.classList.add('is-visible');
    clearTimeout(reloj);
    reloj = setTimeout(cierra, 7000);
  }

  var ultimo = null;
  function revisa() {
    if (!window.anOfertaPara || !window.anOfertaViva) { return; }
    var el = document.querySelector('[data-an-regalo][data-an-total]');
    if (!el) { return; }
    var total = Number(el.getAttribute('data-an-total') || 0);
    if (total === ultimo) { return; }
    ultimo = total;
    var r = window.anOfertaPara(total);
    var o = r.oferta;
    if (!o || total < o.min || (o.max && total > o.max)) { return; }
    var id = o.id + ':' + o.min;
    if (visto(id)) { return; }
    marca(id);
    var todas = [];
    var lista = (window.fgData && window.fgData.offers) || [];
    for (var i = 0; i < lista.length; i++) {
      var p = window.anOfertaPara(Math.round(parseFloat(((lista[i].offer_conditions || [])[0] || {}).min_amount || 0) * 100));
      if (p.oferta && todas.every(function (t) { return t.id !== p.oferta.id; })) { todas.push(p.oferta); }
    }
    todas.sort(function (a, b) { return a.min - b.min; });
    muestra(o, r.siguiente, todas, total);
  }

  var espera = null;
  new MutationObserver(function () {
    clearTimeout(espera);
    espera = setTimeout(revisa, 300);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-an-total'] });
  // fgData llega tarde
  [1500, 4000, 8000].forEach(function (t) { setTimeout(function () { ultimo = null; revisa(); }, t); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cierra(); } });

  // La ventana propia de BOGOS («¡Selecciona tu regalo gratis!») no muestra la
  // escalera y salia encima de este aviso. Si se abre sola, se cierra. Si la
  // pide el tema como respaldo (window.anSliderPedido), se deja.
  // BOGOS usa el mismo evento para abrirse solo, asi que el tema marca
  // window.anSliderPedido justo antes de pedirla.
  new MutationObserver(function () {
    if (Date.now() - (window.anSliderPedido || 0) < 4000) { return; }
    var x = document.querySelector('.sca-is-visible-fg .bogos-slider-close-btn');
    if (x) { x.click(); }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* Escalera de regalos en la ficha. 20-oct-2026.
 * Debajo del precio, los escalones vivos de BOGOS. Sin oferta viva, no existe.
 */
(function () {
  'use strict';
  if (window.anRegaloFicha) { return; }
  window.anRegaloFicha = 1;
  function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO').replace(/,/g, '.'); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  // 31-oct-2026: banda de la ficha (la que aprobo Alejandro). La plantilla ya
  // la trae pintada con el carrito del servidor; aqui solo se ajusta la cifra
  // y la barra con el carrito real y el precio de la variante elegida.
  var TOTAL = null, TOTAL_T = 0;
  function total(cb) {
    if (TOTAL !== null && Date.now() - TOTAL_T < 4000) { cb(TOTAL); return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      TOTAL = Number(c.total_price || 0); TOTAL_T = Date.now(); cb(TOTAL);
    }).catch(function () {});
  }
  function precio(el) {
    var p = Number(el.getAttribute('data-an-precio') || 0);
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (inp) {
      try {
        var mapa = JSON.parse(el.getAttribute('data-an-variantes') || '{}');
        if (mapa[String(inp.value)] !== undefined) { p = Number(mapa[String(inp.value)]); }
      } catch (e) { /* se queda el precio de la plantilla */ }
    }
    return p;
  }
  function pinta() {
    var els = document.querySelectorAll('[data-an-rb]');
    if (!els.length) { return; }
    var todas = window.anOfertasVivas ? window.anOfertasVivas() : [];
    var cargo = !!(window.fgData && window.fgData.offers);
    var charm = null;
    for (var q = 0; q < todas.length; q++) { if (todas[q].min > 100 && todas[q].palabra === 'Charm') { charm = todas[q]; break; } }
    total(function (t) {
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var envio = Number(el.getAttribute('data-an-envio') || 19500000);
        // sin datos de BOGOS todavia, vale la meta de la plantilla; con datos, la de BOGOS
        var meta = charm ? charm.min : (cargo ? 0 : Number(el.getAttribute('data-an-charm') || 0));
        var con = t + precio(el);
        var txt, w;
        if (con < envio) { txt = 'Con este producto te faltan <b>' + pesos(envio - con) + '</b> para el envío gratis'; w = con / envio; }
        else if (meta && con < meta) { txt = 'Con este producto te faltan <b>' + pesos(meta - con) + '</b> para elegir un Charm de regalo'; w = con / meta; }
        else if (meta) { txt = 'Con este producto ya <b>eliges tu Charm</b> de regalo'; w = 1; }
        else { txt = 'Con este producto tu envío es gratis'; w = 1; }
        var t2 = el.querySelector('.an-rb__t2');
        var bar = el.querySelector('.an-rb__bar i');
        if (t2 && t2.innerHTML !== txt) { t2.innerHTML = txt; }
        if (bar) { bar.style.width = Math.max(3, Math.min(100, w * 100)).toFixed(1) + '%'; }
      }
    });
  }
  function otraVez() { TOTAL = null; pinta(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pinta); } else { pinta(); }
  [1500, 4000, 8000].forEach(function (t) { setTimeout(pinta, t); });
  // cambio de variante o de carrito: el cajon se repinta con otro data-an-total
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) { setTimeout(pinta, 150); }
  });
  var visto = '';
  new MutationObserver(function () {
    var r = document.querySelector('[data-an-regalo]');
    var v = r ? r.getAttribute('data-an-total') : '';
    if (v !== visto) { visto = v; otraVez(); }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Escalera de regalos en el carrusel. 20-oct-2026.
 * Llena la diapositiva [data-an-rg] con las ofertas vivas de BOGOS. Si no hay
 * ofertas cuando BOGOS ya cargo, la diapositiva sale del carrusel.
 */
(function () {
  'use strict';
  if (window.anRegalosSlide) { return; }
  window.anRegalosSlide = 1;
  function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO').replace(/,/g, '.'); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function nombre(t) {
    return t.palabra === 'suero' ? 'Suero de 10 ml a elegir'
      : t.palabra === 'regalo' ? t.cuales.split(' o ').map(function (x) { return x.split(' ')[0]; }).join(' o ')
      : t.palabra + (t.varios ? ' a elegir' : '');
  }
  var FOTO = 'https://cdn.shopify.com/s/files/1/0674/6531/4584/files/HYDRA_PEPTIDE_aplicacion_ANIMUS_LAB.png?v=1791577933&width=1400';
  function quita(slide) {
    // el carrusel del tema guarda su Flickity en <slideshow-component>.flkty
    var comp = slide.closest('slideshow-component');
    var f = comp && comp.flkty;
    if (f && f.remove) { f.remove(slide); } else { slide.remove(); }
  }
  var hecho = false;
  function pinta(final) {
    var slides = document.querySelectorAll('[data-an-rg-slide]');
    if (!slides.length || hecho) { return; }
    var todas = window.anOfertasVivas ? window.anOfertasVivas() : [];
    if (!todas.length) {
      if (final) { for (var k = 0; k < slides.length; k++) { quita(slides[k]); } hecho = true; }
      return;
    }
    var hasta = '';
    try {
      hasta = new Date(todas[0].fin - 60000).toLocaleDateString('es-CO',
        { weekday: 'long', day: 'numeric', timeZone: 'America/Bogota' }).replace(',', '');
    } catch (e) { hasta = ''; }
    var etiqueta = function (t) {
      return t.palabra === 'suero' ? 'Suero de 10 ml'
        : t.palabra === 'regalo' ? t.cuales.split(' o ').map(function (x) { return x.split(' ')[0]; }).join(' o ')
        : t.palabra.charAt(0).toUpperCase() + t.palabra.slice(1);
    };
    // 31-oct-2026: con regalo de cualquier compra, el texto dice cual y desde cuanto el otro
    var base0 = todas.filter(function (t) { return t.min <= 100; })[0];
    var meta0 = todas.filter(function (t) { return t.min > 100; })[0];
    var sub = base0 && meta0
      ? 'Toda compra lleva ' + base0.un + '. Si tu pedido llega a ' + pesos(meta0.min) + ', eliges además ' + meta0.un + '.'
      : 'Arma tu rutina y elige en el carrito un detalle para tu piel. Entre más completa tu rutina, más especial el regalo.';
    var html = '<div class="an-rg__in">' +
      '<div class="an-rg__foto"><img src="' + FOTO + '" alt="" loading="eager"></div>' +
      '<div class="an-rg__txt">' +
        '<p class="an-rg__eye">Esta semana</p>' +
        '<h2 class="an-rg__tit">Cuidarte también trae regalo.</h2>' +
        '<p class="an-rg__sub">' + esc(sub) + '</p>' +
        '<div class="an-rg__regalos" role="list">' + todas.map(function (t, i) {
          var r = t.regalos[0] || {};
          return '<div class="an-rg__regalo" role="listitem" style="transition-delay:' + (i * 70) + 'ms">' +
            (r.img ? '<img src="' + esc(r.img) + '" alt="" width="72" height="72" loading="lazy">' : '') +
            '<span>' + esc(etiqueta(t)) + '</span></div>';
        }).join('') + '</div>' +
        '<a class="an-rg__btn" href="/pages/test-de-piel">Arma tu rutina</a>' +
        (hasta ? '<p class="an-rg__hasta">Hasta el ' + esc(hasta) + '.</p>' : '') +
      '</div></div>';
    for (var j = 0; j < slides.length; j++) {
      var box = slides[j].querySelector('[data-an-rg]');
      if (box.getAttribute('data-an-pintado') === html) { continue; }
      box.innerHTML = html;
      box.setAttribute('data-an-pintado', html);
      void box.offsetHeight;
      box.classList.add('is-in');
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { pinta(false); }); } else { pinta(false); }
  [800, 2000, 4000, 6000].forEach(function (t) { setTimeout(function () { pinta(false); }, t); });
  // BOGOS ya cargo a los 10 s; si sigue sin ofertas, la diapositiva sale
  setTimeout(function () { pinta(true); }, 10000);
})();

/* La rutina en el carrito, versión B. 20-oct-2026.
 * Cuatro casillas (Limpia, Trata, Hidrata, Contorno), un paso a la vez con
 * por qué importa y un producto sugerido, y «Completar mi rutina». Las
 * sugerencias salen de las rutinas del test de piel (en Trata sin retinal ni
 * exfoliantes, que son añadidos). Datos del carrito: data-an-lineas en
 * snippets/cart-line-items.liquid. Precios y fotos: /products/<handle>.js.
 */
(function () {
  'use strict';
  if (window.anRutinaCarrito) { return; }
  window.anRutinaCarrito = 1;

  var RUT = {"manchas|mixta": ["limpiador-acido-kojico", "suero-iluminador-trx", "hydra-balance"], "manchas|grasa": ["limpiador-acido-kojico", "suero-iluminador-trx", "hydra-balance"], "manchas|normal": ["limpiador-acido-kojico", "suero-iluminador-trx", "emulsion-hidratante-iluminadora"], "manchas|seca": ["emulsion-limpiadora-doble-limpieza", "suero-iluminador-trx", "emulsion-hidratante-iluminadora"], "imperfecciones|mixta": ["limpiador-facial-bha-2-piel-grasa-con-tendencia-a-acne", "suero-az-hybrid-clear", "hydra-balance"], "imperfecciones|grasa": ["limpiador-facial-bha-2-piel-grasa-con-tendencia-a-acne", "suero-az-hybrid-clear", "hydra-balance"], "imperfecciones|normal": ["limpiador-hidratante-con-acido-hialuronico", "suero-az-hybrid-clear", "emulsion-hidratante-iluminadora"], "imperfecciones|seca": ["emulsion-limpiadora-doble-limpieza", "suero-az-hybrid-clear", "emulsion-hidratante-iluminadora"], "poros|mixta": ["limpiador-facial-bha-2-piel-grasa-con-tendencia-a-acne", "suero-de-niacinamida", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "poros|grasa": ["limpiador-facial-bha-2-piel-grasa-con-tendencia-a-acne", "suero-de-niacinamida", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "poros|normal": ["emulsion-limpiadora-doble-limpieza", "suero-de-niacinamida", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "poros|seca": ["emulsion-limpiadora-doble-limpieza", "suero-de-niacinamida", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "lineas|mixta": ["limpiador-hidratante-con-acido-hialuronico", "suero-multipeptidos", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "lineas|grasa": ["limpiador-hidratante-con-acido-hialuronico", "suero-multipeptidos", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "lineas|normal": ["emulsion-limpiadora-doble-limpieza", "suero-multipeptidos", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "lineas|seca": ["emulsion-limpiadora-doble-limpieza", "suero-multipeptidos", "gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa"], "opaca|mixta": ["limpiador-acido-kojico", "products-suero-vitamina-c-10-antioxidante", "hydra-balance"], "opaca|grasa": ["limpiador-acido-kojico", "suero-antioxidante-renova-c10", "hydra-balance"], "opaca|normal": ["limpiador-acido-kojico", "products-suero-vitamina-c-10-antioxidante", "emulsion-hidratante-iluminadora"], "opaca|seca": ["emulsion-limpiadora-doble-limpieza", "products-suero-vitamina-c-10-antioxidante", "emulsion-hidratante-iluminadora"], "deshidratada|mixta": ["emulsion-limpiadora-doble-limpieza", "suero-hidratante-acido-hialuronico-1-5", "hydra-balance"], "deshidratada|grasa": ["emulsion-limpiadora-doble-limpieza", "suero-hidratante-acido-hialuronico-1-5", "hydra-balance"], "deshidratada|normal": ["emulsion-limpiadora-doble-limpieza", "suero-hidratante-acido-hialuronico-1-5", "emulsion-hidratante-iluminadora"], "deshidratada|seca": ["emulsion-limpiadora-doble-limpieza", "suero-hidratante-acido-hialuronico-1-5", "emulsion-hidratante-iluminadora"]};
  var PISTA = { 'suero-multipeptidos': 'lineas', 'booster-tensor-1': 'lineas', 'hydra-peptide': 'lineas',
    'contorno-multipeptidos': 'lineas', 'suero-triactive-retinoid-nad': 'lineas',
    'suero-exfoliante-bha-2-aha-0-5': 'poros', 'suero-exfoliante-nova-pha': 'poros' };
  var NO_TRATA = /lip-serum|cejas|triactive|exfoliante/;
  var PASOS = [
    { id: 'limpia', nom: 'Limpia', tipo: 'LIMPIADOR', i: 0,
      por: 'Quita la grasa y el sudor del día para que el suero se aplique sobre piel limpia.' },
    { id: 'trata', nom: 'Trata', tipo: 'SUERO', i: 1,
      por: 'El suero es el paso con más activos: trabaja lo que quieres mejorar.' },
    { id: 'hidrata', nom: 'Hidrata', tipo: 'HIDRATANTE', i: 2,
      por: 'Cierra la rutina y ayuda a mantener la piel hidratada y cómoda.' },
    { id: 'contorno', nom: 'Contorno', tipo: 'CONTORNO',
      por: 'La piel alrededor del ojo es más delgada y pide su propia fórmula.' }
  ];
  var PROD = {}, PIDE = {}, foco = null, focoLin = '';

  function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO').replace(/,/g, '.'); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function foto(u, w) {
    if (!u) { return ''; }
    u = String(u).indexOf('//') === 0 ? 'https:' + u : String(u);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // las lineas del carrito: handle y tipo, sin regalos de $0
  function lineas(el) {
    return String(el.getAttribute('data-an-lineas') || '').split('|').filter(Boolean).map(function (x) {
      var p = x.split(':'); return { h: p[0], t: (p[1] || '').toUpperCase() };
    });
  }
  function lleno(paso, ls) {
    for (var i = 0; i < ls.length; i++) {
      var l = ls[i];
      if (l.t === 'KIT' && paso.id !== 'contorno') { return l.h; }
      if (l.t !== paso.tipo) { continue; }
      if (paso.id === 'trata' && NO_TRATA.test(l.h)) { continue; }
      return l.h;
    }
    return null;
  }
  // rutinas del test ordenadas por parecido con el carrito
  function rutinas(ls) {
    var hs = ls.map(function (l) { return l.h; });
    return Object.keys(RUT).map(function (k, n) {
      var s = 0;
      RUT[k].forEach(function (h) { if (hs.indexOf(h) > -1) { s += 2; } });
      hs.forEach(function (h) { if (PISTA[h] && k.indexOf(PISTA[h] + '|') === 0) { s += 1; } });
      return { k: k, s: s, n: n };
    }).sort(function (a, b) { return b.s - a.s || a.n - b.n; });
  }
  function candidatos(paso, ls) {
    var hs = ls.map(function (l) { return l.h; }), out = [];
    if (paso.id === 'contorno') {
      var anti = hs.some(function (h) { return PISTA[h] === 'lineas'; });
      out = anti ? ['contorno-multipeptidos', 'contorno-de-ojos-de-cafeina'] : ['contorno-de-ojos-de-cafeina', 'contorno-multipeptidos'];
    } else {
      rutinas(ls).forEach(function (r) {
        var h = RUT[r.k][paso.i];
        if (out.indexOf(h) < 0) { out.push(h); }
      });
    }
    return out.filter(function (h) { return hs.indexOf(h) < 0; });
  }
  function pide(h, listo) {
    if (PROD[h] || PIDE[h]) { return; }
    PIDE[h] = 1;
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      // el tamaño de entrada sin contar el de 10 ml (ese es el regalo de la semana)
      var ns = vs.filter(function (x) { return !/^10\s*ml$/i.test(String(x.title).trim()); });
      if (ns.length) { vs = ns; }
      vs.sort(function (a, b) { return a.price - b.price; });
      PROD[h] = vs.length ? { h: h, n: p.title, v: vs[0].id, p: vs[0].price,
        tonos: vs.length > 1 && /color/i.test(p.type || '') ? vs.map(function (x) { return { id: x.id, t: x.title }; }) : null,
        ml: vs[0].title !== 'Default Title' && !/color/i.test(p.type || '') ? vs[0].title : '',
        img: (vs[0].featured_image && vs[0].featured_image.src) || p.featured_image } : { h: h, agotado: true };
      listo();
    }).catch(function () { PROD[h] = { h: h, agotado: true }; listo(); });
  }
  // el primer candidato disponible; si falta pedir alguno, se espera
  function sugerido(paso, ls, listo) {
    var cs = candidatos(paso, ls);
    for (var i = 0; i < cs.length && i < 6; i++) {
      var p = PROD[cs[i]];
      if (!p) { pide(cs[i], listo); return undefined; }
      if (!p.agotado && p.p > 0) { return p; }
    }
    return null;
  }

  var COLOR = ['blush-balm', 'glow-balm-paleta', 'blush-balm-bronzer'];
  var NOCHE_ANTI = ['suero-triactive-retinoid-nad', 'suero-exfoliante-bha-2-aha-0-5'];
  var NOCHE = ['suero-exfoliante-bha-2-aha-0-5', 'suero-triactive-retinoid-nad'];
  function primero(lista, ls, listo) {
    var hs = ls.map(function (l) { return l.h; });
    for (var i = 0; i < lista.length; i++) {
      if (hs.indexOf(lista[i]) > -1) { continue; }
      var p = PROD[lista[i]];
      if (!p) { pide(lista[i], listo); return undefined; }
      if (!p.agotado && p.p > 0) { return p; }
    }
    return null;
  }
  function fila(x, eti) {
    return '<div class="an-rut__sug">' + (x.img ? '<img src="' + esc(foto(x.img, 120)) + '" alt="" width="44" height="44" loading="lazy">' : '') +
      '<span><em>' + esc(eti) + '</em><b>' + esc(x.n) + '</b><small>' + pesos(x.p) + (x.ml ? ' · ' + esc(x.ml) : '') + '</small>' +
      (x.tonos ? '<select class="an-rut__tono" aria-label="Tono de ' + esc(x.n) + '">' + x.tonos.map(function (t) {
        return '<option value="' + t.id + '">' + esc(t.t) + '</option>'; }).join('') + '</select>' : '') +
      '</span><button type="button" class="an-rut__add" data-an-rut-add="' + x.v + '"' + (x.tonos ? ' data-an-rut-tono' : '') + '>Agregar</button></div>';
  }

  function premio(total, envio) {
    var t = window.anOfertasVivas ? window.anOfertasVivas() : [];
    var gan = t.filter(function (o) { return total >= o.min; }).pop();
    return { gan: gan, envio: total >= envio };
  }

  function pinta() {
    var els = document.querySelectorAll('[data-an-rut]');
    for (var e = 0; e < els.length; e++) { pintaUno(els[e]); }
  }
  function pintaUno(el) {
    var ls = lineas(el);
    if (!ls.length) { el.hidden = true; return; }
    var total = Number(el.getAttribute('data-an-total') || 0);
    var envio = Number(el.getAttribute('data-an-envio') || 19500000);
    var falta = false;
    var info = PASOS.map(function (p) {
      var h = lleno(p, ls);
      var s = h ? null : sugerido(p, ls, function () { el.removeAttribute('data-an-firma'); pinta(); });
      if (s === undefined) { falta = true; }
      return { p: p, h: h, s: s };
    });
    PASOS.forEach(function (p) { var h = lleno(p, ls); if (h) { pide(h, function () { el.removeAttribute('data-an-firma'); pinta(); }); } });
    if (falta) { return; }
    var firma = el.getAttribute('data-an-lineas') + '|' + total + '|' + foco + '|' + Object.keys(PROD).length +
      '|' + (window.anOfertasVivas ? window.anOfertasVivas().length : 0);
    if (el.getAttribute('data-an-firma') === firma) { return; }
    el.setAttribute('data-an-firma', firma);

    var vacias = info.filter(function (x) { return !x.h && x.s; });
    // si cambia el carrito, el foco vuelve al primer paso que falte
    if (focoLin !== el.getAttribute('data-an-lineas')) { focoLin = el.getAttribute('data-an-lineas'); foco = null; }
    if (!foco || !vacias.some(function (x) { return x.p.id === foco; })) { foco = vacias.length ? vacias[0].p.id : null; }
    var hechos = info.filter(function (x) { return x.h; }).length;

    var cas = info.map(function (x) {
      var pr = x.h ? PROD[x.h] : null;
      var img = pr && pr.img ? '<img src="' + esc(foto(pr.img, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<u aria-hidden="true">+</u>';
      var cls = 'an-rut__ca' + (x.h ? ' is-on' : '') + (x.p.id === foco ? ' is-foco' : '');
      return '<button type="button" class="' + cls + '" data-an-rut-foco="' + x.p.id + '"' + (x.h ? ' disabled' : '') +
        ' aria-label="' + x.p.nom + (x.h ? ': ya en tu carrito' : ': ver por qué importa') + '"><i>' + img + '</i><span>' + x.p.nom + '</span></button>';
    }).join('');

    var f = info.filter(function (x) { return x.p.id === foco; })[0];
    var card = '';
    if (f && f.s) {
      card = '<div class="an-rut__card"><p class="an-rut__h">' + ({ limpia: 'Te falta limpiar', trata: 'Te falta tratar', hidrata: 'Te falta hidratar', contorno: 'Te falta el contorno' }[f.p.id] || 'Te falta: ' + f.p.nom) + '</p><p class="an-rut__por">' + f.p.por + '</p>' +
        '<div class="an-rut__sug">' + (f.s.img ? '<img src="' + esc(foto(f.s.img, 120)) + '" alt="" width="44" height="44" loading="lazy">' : '') +
        '<span><b>' + esc(f.s.n) + '</b><small>' + pesos(f.s.p) + (f.s.ml ? ' · ' + esc(f.s.ml) : '') + '</small></span>' +
        '<button type="button" class="an-rut__add" data-an-rut-add="' + f.s.v + '">Agregar</button></div></div>';
    } else if (!vacias.length) {
      // 20-oct-2026: con la rutina completa se sugieren añadidos: un paso de
      // noche (retinal o exfoliante) y color, cada uno solo si no lo lleva
      var repinta = function () { el.removeAttribute('data-an-firma'); pinta(); };
      var hs0 = ls.map(function (l) { return l.h; });
      // antiedad (Sebastián, 20-oct): Triactive y exfoliante, cada uno si no lo lleva
      var tri = hs0.some(function (h) { return /triactive/.test(h); }) ? null : primero(['suero-triactive-retinoid-nad'], ls, repinta);
      var exf = hs0.some(function (h) { return /exfoliante/.test(h); }) ? null : primero(['suero-exfoliante-bha-2-aha-0-5', 'suero-exfoliante-nova-pha'], ls, repinta);
      var col = ls.some(function (l) { return /COLOR/.test(l.t); }) ? null : primero(COLOR, ls, repinta);
      if (tri === undefined || exf === undefined || col === undefined) { return; }
      var extras = '';
      if (tri || exf) {
        extras += '<p class="an-rut__h an-rut__h--2">¿Te falta algo antiedad?</p>' +
          (tri ? fila(tri, 'Antiedad · retinal') : '') + (exf ? fila(exf, 'Renovación · exfoliante') : '') +
          '<p class="an-rut__nota">Van solo de noche y en noches intercaladas. El retinal no se usa en embarazo ni lactancia.</p>';
      }
      if (col) {
        extras += '<p class="an-rut__h an-rut__h--2">Un toque de color</p>' + fila(col, 'Skincare + Color');
      }
      card = '<div class="an-rut__card"><p class="an-rut__h">Tu rutina está completa</p>' +
        (extras || '<p class="an-rut__por">Ya tienes los cuatro pasos de tu rutina.</p>') + '</div>';
    }

    // completar: los tres pasos básicos que falten
    var base = info.filter(function (x) { return x.p.id !== 'contorno' && !x.h && x.s; });
    var boton = '';
    if (base.length) {
      var suma = base.reduce(function (s, x) { return s + x.s.p; }, 0);
      var antes = premio(total, envio), despues = premio(total + suma, envio);
      var gana = '';
      if (despues.gan && (!antes.gan || despues.gan.min > antes.gan.min)) {
        gana = 'Con tu rutina completa desbloqueas ' + (despues.gan.palabra === 'regalo' ? despues.gan.cuales : (despues.gan.un || 'un ' + despues.gan.palabra)) + ' de regalo';
      } else if (despues.envio && !antes.envio) {
        gana = 'Con tu rutina completa llegas al envío gratis';
      } else {
        gana = 'Agrega ' + base.map(function (x) { return { limpia: 'limpiador', trata: 'suero', hidrata: 'hidratante' }[x.p.id] || x.p.nom.toLowerCase(); }).join(', ').replace(/, ([^,]*)$/, ' e $1').replace(/ e ([^h])/, ' y $1');
      }
      boton = '<button type="button" class="an-rut__todo" data-an-rut-todo="' + base.map(function (x) { return x.s.v; }).join(',') + '">' +
        'Completar mi rutina · +' + pesos(suma) + '<small>' + esc(gana) + '</small></button>';
    }

    el.innerHTML = '<p class="an-rut__tit">Tu rutina · ' + hechos + ' de 4</p>' +
      (vacias.length && hechos <= 1 ? '<p class="an-rut__sub">Toca un paso para ver por qué importa.</p>' : '') +
      '<div class="an-rut__cas">' + cas + '</div>' + card + boton +
      (hechos <= 1 ? '<p class="an-rut__test">¿No sabes cuál va con tu piel? <a href="/pages/test-de-piel">Haz el test de piel</a></p>' : '');
    el.hidden = false;
  }

  function agrega(ids, b) {
    if (b.getAttribute('data-enviando')) { return; }
    b.setAttribute('data-enviando', '1');
    b.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) { throw new Error('no se pudo agregar'); }
      if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      b.removeAttribute('data-enviando');
      b.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-an-rut-foco],[data-an-rut-add],[data-an-rut-todo]');
    if (!t) { return; }
    e.preventDefault();
    if (t.hasAttribute('data-an-rut-foco')) {
      if (t.disabled) { return; }
      foco = t.getAttribute('data-an-rut-foco');
      var el = t.closest('[data-an-rut]');
      var card = el && el.querySelector('.an-rut__card');
      if (card) {
        card.classList.add('is-out');
        setTimeout(function () { el.removeAttribute('data-an-firma'); pintaUno(el); }, 160);
      } else { pinta(); }
      return;
    }
    if (t.hasAttribute('data-an-rut-add')) {
      var sel = t.hasAttribute('data-an-rut-tono') && t.parentNode.querySelector('.an-rut__tono');
      agrega([sel ? sel.value : t.getAttribute('data-an-rut-add')], t); return;
    }
    agrega(t.getAttribute('data-an-rut-todo').split(','), t);
  });

  var espera = null;
  function agenda() { clearTimeout(espera); espera = setTimeout(pinta, 120); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', agenda); } else { agenda(); }
  new MutationObserver(agenda).observe(document.documentElement, { childList: true, subtree: true });
  [1500, 4000, 8000].forEach(function (t) { setTimeout(function () { document.querySelectorAll('[data-an-rut]').forEach(function (x) { x.removeAttribute('data-an-firma'); }); pinta(); }, t); });
})();
